import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';
import { useAuth } from '../../context/AuthContext';

const TrainerLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
 const location = useLocation();
  const isLocationcontain = location.pathname.includes('dashboard')

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const trainerNavItems = [
    { label: 'Dashboard', path: '/manager/dashboard', icon: <i className="bi bi-grid-fill"></i> },
    { label: 'Staff Management', path: '/manager/staff-management', icon: <i className="bi bi-people-fill"></i> },
    { label: 'Course Management', path: '/manager/courses', icon: <i className="bi bi-book"></i> },
    { label: 'Policy Management', path: '/manager/policies', icon: <i className="bi bi-shield-lock"></i> },
    { label: 'News And Announcements', path: '/manager/news-announcement', icon: <i className="bi bi-shield-lock"></i> },
    { label: 'Leaderboard', path: '/manager/leaderboard', icon: <i className="bi bi-bar-chart-line"></i> },
    { label: 'Updates', path: '/manager/updates', icon: <i className="bi bi-rss"></i> },
    { label: 'Sales Management', path: '/manager/sales', icon: <i className="bi bi-person"></i> },
    { label: 'Profile', path: '/manager/profile', icon: <i className="bi bi-person"></i> },

  ];
  return (
    <div className="staff-layout d-flex">
    {/* Sidebar always on the left, full height */}
    <Sidebar navItems={trainerNavItems} onLogout={handleLogout}/>
  
    {/* Right side: content area (navbar + main content) */}
    <div className="content-wrapper flex-grow-1 d-flex flex-column">
      {
        isLocationcontain &&
         <Navbar 
        username={user?.fullName}
        userRole={user?.role}
        onLogout={handleLogout}
      />
      }
     
  
      <main className="main-content flex-grow-1" style={{backgroundColor:'#F5F5FD'}}>
        <Outlet />
      </main>
    </div>
  </div>
   
  );
};

export default TrainerLayout;